import { PictureIcon } from '@teamturing/icons';
import React from 'react';

import Image from '../../core/Image';
import Text from '../../core/Text';
import View from '../../core/View';

type Props = {
  withExpandedScreen?: boolean;

  subText?: string;
  title?: string;

  imageUrl?: string | null;
};

const PromotionAppMiniBannerPreview = ({ withExpandedScreen, title, subText, imageUrl }: Props) => {
  const scale = withExpandedScreen ? 0.5 : 0.67;
  const paddingX = `${withExpandedScreen ? 80 : 20}px`;

  return (
    <View
      sx={{
        height: 96 * scale,
        transformOrigin: 'left top',
        transform: `scale(${scale})`,
      }}
    >
      <View
        backgroundColor={'#F3F4F6'}
        position={'relative'}
        overflow={'hidden'}
        marginRight={`-${(100 / (scale * 100)) * (1 - scale) * 100}%`}
      >
        <View
          height={148}
          width={148}
          backgroundColor={imageUrl ? 'transparent' : '#E5E7EB'}
          position={'absolute'}
          top={'50%'}
          right={paddingX}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            transform: 'translateY(-50%)',
          }}
        >
          {imageUrl ? (
            <Image src={imageUrl} alt={imageUrl} html style={{ display: 'block' }} />
          ) : (
            <PictureIcon width={40} height={40} color={'#8D94A0'} />
          )}
        </View>
        <View px={paddingX} py={'24px'} position={'relative'}>
          <View>
            <Text fontWeight={500} fontSize={'14px'} color={'#7A828D'} lineHeight={1.5}>
              {subText || '서브 텍스트'}
            </Text>
          </View>
          <Text fontWeight={700} fontSize={'18px'} color={'#33373B'} lineHeight={1.5}>
            {title || `최대 1줄\n이미지에 안 겹치게`}
          </Text>
        </View>
        <View
          borderRadius={9999}
          py={'2px'}
          px={'8px'}
          backgroundColor={'rgba(0, 0, 0, 0.60)'}
          position={'absolute'}
          right={paddingX}
          bottom={'8px'}
          lineHeight={0}
        >
          <Text fontSize={'10px'} color={'white'} lineHeight={'15px'}>
            1 / 2
          </Text>
        </View>
      </View>
    </View>
  );
};

export default PromotionAppMiniBannerPreview;
export type { Props as IndexProps };
